import { render, staticRenderFns } from "./ProductSalesChart.vue?vue&type=template&id=a1be9cc8&"
import script from "./ProductSalesChart.vue?vue&type=script&lang=js&"
export * from "./ProductSalesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports